import { render } from "./MedicationSubCategoryCard.vue?vue&type=template&id=600250c9"
import script from "./MedicationSubCategoryCard.vue?vue&type=script&lang=js"
export * from "./MedicationSubCategoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__